export const config = {
    appname: 'KSAM',
    client_id: '1466874510372612', // App ID
    facebook_app_id: '1466874510372612', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'apiksw',
    agency_id: '',
    bzbsUrlOldSupport: 'https://stg.buzzebees.com',
    bzbsUrl: 'https://apiksw.buzzebees-uat.com',
    bzbsModuleUrl: 'https://stg-module-app.azurewebsites.net',
    apiShoppingCartUrl: 'https://shoppingcartmodule3.buzzebees-uat.com',
    webShoppingCartUrl: 'https://shoppingcartservice3.buzzebees-uat.com',
    bzbsBlobUrl: 'https://stgstoragebuzzebees.blob.core.windows.net',
    miscUrl: 'https://stgmisc.buzzebees.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "AIzaSyBf-27nLEdqu0AECg7_pgH1bP80av2o5Iw",
        authDomain: "ksam-staging.firebaseapp.com",
        projectId: "ksam-staging",
        storageBucket: "ksam-staging.appspot.com",
        messagingSenderId: "298699542244",
        appId: "1:298699542244:web:29c20ba9843229864d66f1",
        measurementId: "G-XY1P251C4G"
    },
};
